/**
 *  配电表计管理
 */
import * as HttpService from "../../../../service/HttpService";

/**
 * 查询配电监控设备列表
 */
export const queryMonitorList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMonitor/monitorList",params);
};

/**
 * 新增监控设备
 */
export const addMonitor = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMonitor/addMonitor", params);
};

/**
 * 编辑监控前获取所选设备信息
 */
export const queryMonitorByMondevId = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/instCamera/getMondevInfoById?mondevId="+params);
};

/**
 * 编辑监控设备
 */
export const editMonitor = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMonitor/editMonitor", params);
};

/**
 * 删除监控设备
 */
export const deleteMonitor = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMonitor/deleteMonitor", params);
};
